import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import SideMenu from '../SideMenu';
import MainContent from '../MainContent';
import Footer from '../Footer';
import './index.scss';

const Category = ({ category }) => (
    <Fragment>
        <Header category={category}/>
        <div className="lists-wrapper max-width-container">
            <SideMenu category={category}/>
            <MainContent items={category.items}/>
        </div>
        <Footer/>
    </Fragment>
);

Header.propTypes = {
    category: PropTypes.object
};

export default Category;
